import { render, staticRenderFns } from "./yi_ysx_settled.vue?vue&type=template&id=0715c4dd&scoped=true"
import script from "./yi_ysx_settled.vue?vue&type=script&lang=js"
export * from "./yi_ysx_settled.vue?vue&type=script&lang=js"
import style0 from "./yi_ysx_settled.vue?vue&type=style&index=0&id=0715c4dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715c4dd",
  null
  
)

export default component.exports